"use client";
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import * as React from 'react';
import { Icon } from '../../Icon/Icon.web.js';

var _excluded = ["color", "size"];
var IconFinalDisposal = function IconFinalDisposal(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === undefined ? 'currentColor' : _ref$color,
    _ref$size = _ref.size,
    sizeProp = _ref$size === undefined ? '48px' : _ref$size,
    props = _objectWithoutProperties(_ref, _excluded);
  var size = sizeProp;
  return /*#__PURE__*/React.createElement(Icon, props, /*#__PURE__*/React.createElement("svg", {
    fill: "none",
    viewBox: "0 0 48 48",
    width: size,
    height: size
  }, /*#__PURE__*/React.createElement("path", {
    fill: color,
    fillRule: "evenodd",
    d: "M33 5v15.984c5.117.994 8.98 5.499 8.98 10.906 0 6.136-4.974 11.11-11.11 11.11-3.431 0-6.5-1.556-8.537-4H8v-2h13.002a11.06 11.06 0 0 1-1.242-5.11c0-6.136 4.974-11.11 11.11-11.11H31V7H12v3h14v1H12v14.58c0 2.234-.914 5.053-2.444 8.173l-.213.427-1.786-.9c1.461-2.9 2.362-5.519 2.438-7.442L10 25.58V5zm3.342 19.606A9.11 9.11 0 0 0 23.75 37.574zm1.458 1.37L25.162 38.99A9.11 9.11 0 0 0 37.8 25.976M44 24V12h-9v2h7v10zM22 41v2H12v-2z",
    clipRule: "evenodd"
  })));
};

export { IconFinalDisposal, IconFinalDisposal as default };
